import { APP_TOKENS } from "./tokens";

export const ADMIN_TOKENS = {
  color: {
    ...APP_TOKENS.color,
    surfaceAccent: "#EEF7FF",
    borderMuted: "#EEF2F8",
    borderStrong: "#D5DCE7",
    borderAccent: "#CFE9FF",
    borderInput: "#C4C6CD",
    textSubtle: "#616A7D",
    textTertiary: "#677085",
    textInverse: "#111827",
    accentAlt: "#5B63F6",
    accentDark: "#0C5D9A",
    idle: "#9AA3B2",
    errorTextStrong: "#861515",
  },
  spacing: APP_TOKENS.spacing,
  radius: APP_TOKENS.radius,
  borderWidth: {
    sm: APP_TOKENS.borderWidth.thin,
  },
  font: {
    ...APP_TOKENS.font,
    extrabold: "Urbanist800",
  },
  fontSize: APP_TOKENS.fontSize,
  lineHeight: APP_TOKENS.lineHeight,
  zIndex: APP_TOKENS.zIndex,
  motion: APP_TOKENS.motion,
  size: {
    cardMinWidth: 240,
    authButtonMinWidth: 180,
    inlineButtonMinWidth: 140,
    dateFieldMinWidth: 210,
    chartHeight: 220,
    chartInnerHeight: 190,
    chartBucketWidth: 48,
    chartBarWidth: 16,
    chartYAxisPadding: 26,
    chartMaxBaseline: 10,
    chartMinBarHeight: 2,
    miniTrendHeight: 22,
    miniTrendBarWidth: 4,
    miniTrendMinBarHeight: 2,
    tableTrendMinWidth: 80,
    tableMinWidth: 720,
    quickButtonMinWidth: 220,
    searchButtonMinWidth: 80,
    eventCardMaxWidth: 500,
    // Keeps the direct-link form legible without making the setup page excessively tall.
    formPreviewHeight: 750,
    tableClinicFlex: 1.4,
    badgeMinWidth: 180,
    inputHeight: 46,
    contentMaxWidth: 760,
  },
  opacity: {
    full: 1,
    muted: 0.5,
    disabled: 0.6,
  },
  shadow: {
    none: {},
    card: APP_TOKENS.shadow.card,
  },
} as const;
